export default __webpack_public_path__ + "static/1317-2f4a5b0f7f14764d4f327434d37ee9c5.gif";